import type { ImageRef } from '@/api/types';

/** Fill an image template's `{w}` / `{h}` placeholders. */
export function imageUrl(ref: ImageRef | null | undefined, w: number, h: number): string | null {
  if (!ref) return null;
  if (ref.template) return ref.template.replace(/\{w\}/g, String(w)).replace(/\{h\}/g, String(h));
  return ref.url || null;
}

export const ARTWORK_SLOTS = [
  {
    slot: 'poster',
    label: 'Poster',
    ratio: 2 / 3,
    hint: 'Portrait 2:3, at least 1000 × 1500 px.',
    preview: [200, 300],
  },
  {
    slot: 'landscape',
    label: 'Landscape',
    ratio: 16 / 9,
    hint: 'Landscape 16:9, at least 1920 × 1080 px. Used for programme pages and the hero.',
    preview: [480, 270],
  },
  {
    slot: 'thumb',
    label: 'Thumbnail',
    ratio: 16 / 9,
    hint: 'Landscape 16:9, at least 640 × 360 px. Used on cards in rows.',
    preview: [320, 180],
  },
  {
    slot: 'title_art',
    label: 'Title art (optional)',
    ratio: 3 / 1,
    hint: 'Transparent PNG of the logo/title, wide (about 3:1), at least 1200 px wide.',
    preview: [420, 140],
  },
] as const;
